import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '../../../app/store';

// Define the Contact type
export interface Contact {
  id: string | number;
  fullName: string;
  email: string;
  message: string;
  createdAt: string;
  updatedAt: string;
  isRead: boolean;
}

// Define the state type
export interface ContactState {
  contacts: Contact[];
}

// Retrieve contacts from localStorage, default to an empty array if not found
const storedContacts = localStorage.getItem('contactList');
const initialState: ContactState = {
  contacts: storedContacts ? JSON.parse(storedContacts) : [],
};

const ContactReducer = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setContactsCredentials: (state, action: PayloadAction<Contact[]>) => {
      state.contacts = action.payload;
      localStorage.setItem('contactList', JSON.stringify(action.payload));
    },
    updateContactIsRead: (
      state,
      action: PayloadAction<{id: string | number; isRead: boolean}>
    ) => {
      const {id, isRead} = action.payload;
      const contactIndex = state.contacts.findIndex(
        (contact) => contact.id === id
      );
      if (contactIndex !== -1) {
        state.contacts[contactIndex].isRead = isRead;
        localStorage.setItem('contactList', JSON.stringify(state.contacts));
      }
    },
  },
});

// Export actions
export const {setContactsCredentials, updateContactIsRead} =
  ContactReducer.actions;

// Selector
export const selectContacts = (state: RootState) => state.contacts.contacts;

// Export reducer
export default ContactReducer.reducer;
